export default __webpack_public_path__ + "static/404-pattern-orange-1a047cb826068a1a618c18b263db6062.svg";